import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { TranslationService } from 'src/app/Service/translation.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { FormApprovalSuccessModalComponent } from '../form-approval-success-modal/form-approval-success-modal.component';
import { FullScreenPopupComponent } from '../full-screen-popup/full-screen-popup.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CONSTANTS } from 'src/Core/Constant';

@Component({
  selector: 'app-seva-profile-aggrement',
  templateUrl: './seva-profile-aggrement.component.html',
  styleUrls: ['./seva-profile-aggrement.component.scss']
})
export class SevaProfileAggrementComponent {

  isJsonShow = environment.isJsonShow;
  @Input() applicantData: any; // Accept data from parent component
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  toogleBool: boolean = true;
  isCodeOfConductAccept = false
  @Output() navigateToFirstTab: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigateToInvalidTab = new EventEmitter<any>();
  aggrementForm!: FormGroup;
  isEditable: boolean = true; // Flag to track if the form is editable
  constructor(private fb: FormBuilder, public genericValidations: GenericValidationsService, private toastr: ToastrService, private api: SevaProfileService, private router: Router, private dialogService: NbDialogService, private translationService: TranslationService) { }
  SaveMode = CONSTANTS.SAVE_MODE;

  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }

  ngOnInit(): void {
    if (!this.isPreviewMode) {
      // Execute only when not in preview mode
      this.initializeForm();
      this.getApplicantData();
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicantData'] && this.applicantData) {
      this.initializeForm();
      this.aggrementForm.patchValue(this.applicantData);
      this.aggrementForm.disable();
    }
  }


  getApplicantData() {
    this.api.apiCall('UserConsent/GetUserConsent', 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%

        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.aggrementForm.disable();
        } else {
          this.aggrementForm.enable();
        }

        this.aggrementForm.patchValue(response.Data);
      }
    })
  }

  initializeForm() {
    this.aggrementForm = this.fb.group({
      IsAggrementAccepted: ['', Validators.required],
      AggrementAcceptedDate: [new Date().toISOString()],
      SaveMode: this.SaveMode.SAVE,
    
    });
  }


  proceed() {


    if (!this.aggrementForm.valid) {

      // Add 'submitted' class manually to all invalid controls
      Object.keys(this.aggrementForm.controls).forEach((field) => {
        const control = this.aggrementForm.get(field);
        if (control && control.invalid) {
          control.markAsTouched(); // Ensure ng-touched is triggered
          const element = document.getElementById(field);
          if (element) {
            element.classList.add('submitted'); // Add 'submitted' class to invalid elements
          }
        }
      });

      return
    }

    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.aggrementForm.value);
    this.OpenModal(cleanedValues, this.SaveMode.SAVE);


  }




  showIncompleteTabsModal(incompleteTabs: any[]) {
    const dialogRef = this.dialogService.open(FullScreenPopupComponent, {
      context: {
        title: 'Incomplete Tabs',
        message: 'Following tabs are incomplete. Please complete them before submission.',
        tabs: incompleteTabs

      },
      closeOnBackdropClick: false,
      hasScroll: true
    });

    dialogRef.onClose.subscribe(res => {
      if (res.isApproval) {
        // Proceed with the submission

      }
      if (res.isInvalidTabs) {
        this.navigateToInvalidTab.emit(res.tabData);

      }


    });
  }



  goToBack(): void {
    this.previous.emit();
  }






  showAgreementModal() {
    const dialogRef = this.dialogService.open(FullScreenPopupComponent, {
      context: {
        title: 'Incomplete Tabs',
        message: 'Following tabs are incomplete. Please complete them before submission.',
        tabs: [],
        isForAgrrment: true

      },
      closeOnBackdropClick: false,
      hasScroll: true
    });

    dialogRef.onClose.subscribe(res => {
      if (res.isApproval) {
        // Proceed with the submission
        // this.addUpdate(this.requestedDatesForm.value, this.SaveMode.SAVE);
      }
      if (res.isInvalidTabs) {
        this.navigateToInvalidTab.emit(res.tabData);

      }
    });
  }




  OpenModal(cleanedValues: any, Mode: any) {
    const dialogRef = this.dialogService.open(ConfirmationModalComponent, {
      context: {
        data: {
          'title': 'Confirm Submission',
          'message': 'Do you want to review your Seva Profile once or submit?',
          'name': 'Chetan',
          'city': "Malegaon",
        }
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res.isApproval === true) {
        this.addUpdate(cleanedValues, Mode);
        // this.FormApproveSucessfully()
        // this.getAllApplication(); 
      } else if (res.isReview === true) {
        this.navigateToFirstTab.emit();
      }
    });
  }




  addUpdate(reqBody: any, Mode: number) {

    let payload = 
      {"IsAggrementAccepted":reqBody.IsAggrementAccepted,
        "AggrementAcceptedDate":new Date().toISOString(),
        "SaveMode":this.SaveMode.SAVE,
 
      }
 



  this.api.apiCall('UserConsent/SaveUserConsent', 'POST', payload).subscribe(
    (response: any) => {
      const completionPercentage = response?.Data?.ProfileCompletionDetails?.CompletionPercentage ?? 0;
      // const incompleteTabs = response?.Data?.IncompleteTabDetails ?? [];
      // if (incompleteTabs && incompleteTabs.length > 0) {
      //   this.showIncompleteTabsModal(incompleteTabs);
      // } else {
        this.toastr.success(response?.Message);
        if (Mode === this.SaveMode.SAVE) {
          this.FormApproveSucessfully(response?.Message);
        } else if (Mode === this.SaveMode.DRAFT) {
          this.getApplicantData();
        }
      // }
    },
    (err: any) => {
      console.error('API Error:', err);

      // const completionPercentage = err?.error?.Data?.ProfileCompletionDetails?.CompletionPercentage ?? 0;
      const incompleteTabs = err?.error?.Data?.IncompleteTabDetails ?? [];
  
      if (incompleteTabs && incompleteTabs.length > 0) {
        this.showIncompleteTabsModal(incompleteTabs);
      } 
   
    }
  );


}



  addUpdateold(reqBoby: any, Mode: number) {
    this.api.apiCall('UserConsent/SaveUserConsent', 'POST', reqBoby).subscribe((response: any) => {
      // this.toastr.success(response?.Message);

      if (response.Data?.ProfileCompletionDetails?.CompletionPercentage < 100  ||  response?.Data?.IncompleteTabDetails?.lr) {
        this.showIncompleteTabsModal(response.Data.IncompleteTabDetails);
      } else {

        this.toastr.success(response?.Message);
        if (Mode === this.SaveMode.SAVE) {
          this.FormApproveSucessfully(response?.Message);
        } else if (Mode === this.SaveMode.DRAFT) {
          this.getApplicantData();
        }
      }
    });
  }



  FormApproveSucessfully(message: any) {


    const dialogRef = this.dialogService.open(FormApprovalSuccessModalComponent, {
      context: {
        data: {
          'name': 'Chetan',
          'message': message,
          'city': "Malegaon",
        }
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {

        this.router.navigate(['applicant/profile-summary'])
        // this.getAllApplication();  // Handle approval
      } else {

      }
    });

  }




}
